import apiClient from "../../apis/tenant-management/tenant-management-client";
import { toast } from "react-toastify";
import { BaseApplicationService } from "../../domain/base/base-application-service";
import { Acl, AddressSetting } from "../../domain/acl";
import { reportUnexpectedError } from "../../../error-reporter";

export type OrganizationAclServiceProps = {
  isLoading: boolean;
  acl: Acl | undefined;
  fetchOrganizationACL: typeof OrganizationAclService.prototype.fetchOrganizationACL;
  onCreateOrganizationACL: typeof OrganizationAclService.prototype.onCreateOrganizationACL;
  onUpdateOrganizationACL: typeof OrganizationAclService.prototype.onUpdateOrganizationACL;
};

export class OrganizationAclService extends BaseApplicationService<OrganizationAclServiceProps> {
  state = {
    isLoading: false,
    acl: undefined,
    fetchOrganizationACL: this.fetchOrganizationACL.bind(this),
    onCreateOrganizationACL: this.onCreateOrganizationACL.bind(this),
    onUpdateOrganizationACL: this.onUpdateOrganizationACL.bind(this),
  };

  // org-acl-setting
  async onCreateOrganizationACL(
    ipAddresses: Array<AddressSetting>,
    organizationId: string,
  ) {
    await this.createOrganizationACL(organizationId, ipAddresses);
    await this.fetchOrganizationACL(organizationId);
  }

  async onUpdateOrganizationACL(
    aclId: string,
    ipAddresses: Array<AddressSetting>,
    organizationId: string,
  ) {
    await this.updateOrganizationACL(organizationId, aclId, ipAddresses);
    await this.fetchOrganizationACL(organizationId);
  }

  async fetchOrganizationACL(organizationId: string) {
    this.setIsLoading(true);
    try {
      const { data: acl } =
        await apiClient.fetchOrganizationACL(organizationId);
      this.setState({
        acl: acl,
      });
    } catch (e) {
      if (e.response.data.code === "not_found") {
        return;
      }
      reportUnexpectedError(e);
      toast.error("テナント情報の取得に失敗しました");
    } finally {
      this.setIsLoading(false);
    }
  }

  private async createOrganizationACL(
    organizationId: string,
    ipAddresses: Array<AddressSetting>,
  ) {
    this.setIsLoading(true);
    try {
      await apiClient.createOrganizationACL(organizationId, ipAddresses);
      toast.success("ACLの設定を追加しました");
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("ACLの設定を追加に失敗しました");
    } finally {
      this.setIsLoading(false);
    }
  }

  private async updateOrganizationACL(
    organizationId: string,
    aclId: string,
    ipAddresses: Array<AddressSetting>,
  ) {
    this.setIsLoading(true);
    try {
      await apiClient.updateOrganizationACL(organizationId, aclId, ipAddresses);
      toast.success("ACLの設定を変更しました");
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("ACLの設定を変更に失敗しました");
    } finally {
      this.setIsLoading(false);
    }
  }

  private setIsLoading(isLoading: boolean) {
    this.setState({
      isLoading: isLoading,
    });
  }
}
